import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {Organization} from '../../modules/organization/models/organization';
import {API} from '@configs/api.config';
import { HttpClient } from '@angular/common/http';
import {OrgDetails} from '../models/org-details.model';

@Injectable({
  providedIn: 'root'
})
export class SharedOrganizationService {

  constructor(private httpClient: HttpClient) { }

  getOrganizationsByVertical(vertical: string): Observable<Organization[]> {
    const url = API.organization.getOrganizationsByVertical.format([vertical]);
    return this.httpClient.get<Organization[]>(url);
  }

  getOrgDetails(orgIds: string[]): Observable<OrgDetails[]> {
    const url = API.organization.getOrgDetails;
    return this.httpClient.post<OrgDetails[]>(url, orgIds);
  }
}
